<template>
  <app-layout class="advocay-template">
      <Row type="flex" justify="center">
        <Col :span="24" v-for="(menu, k) in menuList" :key="k">
          <MenuListComponent :item="menu"></MenuListComponent>
        </Col>
      </Row>
  </app-layout>
</template>

<script>
import MenuListComponent from '@/components/MenuListComponent'
import Cons from '@/constants.json'

export default {
  name: 'PeopleMenuComponent',
  components: {
    MenuListComponent
  },
  data() {
    return {

    }
  },
  methods:{
      getCountryProvinceCity(){
        this.$store.dispatch("user/getCountryProvinceCity").then(
        res=> {

        }, err=> {

        });
      }
  },
  computed:{
    nearbyId: {
      get() {
        return this.$store.state.user.nearby.city.id || this.$store.state.user.nearby.province.id || this.$store.state.user.nearby.country.id || ''
      },
    },
    menuList: {
        get(){
            return [
                { type: 'people', title: 'Latest', link: '/people', icon:'/img/resources/latest.svg' ,id: Cons[0].GROUP_ID.donate},
                { type: 'people', title: 'Nearby', link: '/people', icon:'/img/resources/nearby-filled.svg' , id: this.nearbyId},
                { type: 'people', title: 'Senate of the Philippines', link: '/people', icon:'/img/resources/senate.png' , id: Cons[0].GROUP_ID.SenatePhilippinesId[process.env.VUE_APP_DEV_STATUS]},
                { type: 'people', title: 'Consultative Committee', link: '/people', icon:'/img/resources/comittee.png' , id: Cons[0].GROUP_ID.ConsultativeCommitteeId[process.env.VUE_APP_DEV_STATUS]},
                { type: 'people', title: 'By advocacies', link:  '/group-type/interest' , icon:'/img/resources/Advocacies.png' , id:''},
                { type: 'people', title: 'Featured', link: '/people', icon:'/img/resources/star_gold_256.png' , id: Cons[0].GROUP_ID.featuredMembersBadgeId[process.env.VUE_APP_DEV_STATUS]},
            ]
        }
    }
  },
  mounted(){
    this.getCountryProvinceCity();
    this.$store.dispatch('user/getResourceInterest', {type: 'interest'});
  }
}
</script>
